import { PropsWithChildren, ReactNode } from 'react';

import { makeStyles } from '@material-ui/core/styles';

import classNames from 'classnames';

export type SidebarContentProps = PropsWithChildren<{
  sideBarRight?: ReactNode;
  sideBarRightClassName?: string;
  sideBarLeft?: ReactNode;
  className?: string;
}>;

const useStyles = makeStyles(
  theme => ({
    container: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: theme.spacing(3),
    },
    sidebar: {
      flex: '1 1 100%',
      minWidth: 0,
      '&:empty': {
        display: 'none',
      },
      [theme.breakpoints.up('md')]: {
        flex: '0 0 33.333%', // Fixed at 4/12 columns
      },
      [theme.breakpoints.up('lg')]: {
        flex: '0 0 25%', // Fixed at 3/12 columns
      },
    },
    content: {
      flex: '1 1 100%',
      minWidth: 0,
      [theme.breakpoints.up('md')]: {
        flex: '1 1 0', // Grow to fill remaining space
      },
    },
  }),
  { name: 'SidebarContent' },
);

export const SidebarContent = ({
  children,
  sideBarRight,
  sideBarRightClassName,
  sideBarLeft,
  className,
}: SidebarContentProps) => {
  const classes = useStyles();

  return (
    <div className={classNames(classes.container, className)}>
      {sideBarLeft && <div className={classes.sidebar}>{sideBarLeft}</div>}
      <div className={classes.content}>{children}</div>
      {sideBarRight && (
        <div className={classNames(classes.sidebar, sideBarRightClassName)}>
          {sideBarRight}
        </div>
      )}
    </div>
  );
};
